import * as yup from 'yup'

export const schemaCreatePartnerContractModal = yup.object().shape({
    contract_number_id: yup.string().required('contract-number-required'),
    // partner_id is validated manually in onSubmit (can be created via QuickCreateSupplier)
    partner_id: yup.number().nullable(),
    contract_key: yup.string().nullable(),
    contract_effective_date: yup.date().nullable(),
    contract_expiry_date: yup.date().nullable(),
    contract_value: yup.number().nullable(),
    contract_note: yup.string().nullable(),
})
